import { useContext, useEffect } from "react";
import { FRESHCHAT_TOKEN, FRESHCHAT_HOST, FRESHCHAT_WIDGET_UUID } from "../../Config/Environment";
import { FixtureDetailsContext } from "../../Config/FixtureDetails";

const settings = {
  token: FRESHCHAT_TOKEN,
  host: FRESHCHAT_HOST,
  widgetUuid: FRESHCHAT_WIDGET_UUID,
  tags: ["hblscout"],
};

const FreshChat = (props) => {
  const { currentState, onInit } = props;
  const { fixtureId } = useContext(FixtureDetailsContext);

  const initChatUserProperties = (userName, fixtureId) => {
    const firstName = userName.split(" ")[0];
    const lastName = userName.split(" ").slice(1).join(" ") ?? "";
    fcWidget.user.setProperties({
      firstName: firstName,
      lastName: lastName,
      fixtureId: fixtureId,
    });
  };

  const loadScript = () => {
    let id = "Freshchat-js-sdk";
    if (document.getElementById(id) || window.fcWidget) return;
    let script = document.createElement("script");
    script.async = "true";
    script.src = `${FRESHCHAT_HOST}/js/widget.js`;
    script.id = id;
    document.head.appendChild(script);
  };

  const lazyInit = () => {
    loadScript();
    const interval = setInterval(() => {
      if (window.fcWidget) {
        clearInterval(interval);
        window.fcWidget.init({
          ...settings,
          ...props,
        });
        onInit && onInit(window.fcWidget);
      }
    }, 1000);
  };

  const handleUnmount = () => {
    if (window.fcWidget) {
      window.fcWidget.close();
    }
  };

  useEffect(() => {
    if (!window.fcWidget) {
      lazyInit();
    }
  }, []);

  useEffect(() => {
    if (window.fcWidget?.isInitialized() && window.fcWidget?.isLoaded() && currentState?.sessionInfo && fixtureId) {
      const fullName = currentState.sessionInfo.name;
      initChatUserProperties(fullName, fixtureId);
    }
  }, [window.fcWidget?.isInitialized(), window.fcWidget?.isLoaded(), currentState?.sessionInfo, fixtureId]);

  useEffect(() => {
    return handleUnmount;
  }, []);

  return <></>;
};

export default FreshChat;
